import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { homeFor, useAuth } from "../context/AuthContext";

export default function NotFound() {
    const { user } = useAuth();

    return (
        <div className="flex flex-col items-center justify-center text-center py-24">
            <p className="text-7xl font-black bg-gradient-to-r from-[#8b5cf6] to-[#6d28d9] bg-clip-text text-transparent">404</p>
            <h1 className="text-xl font-bold text-white mt-4">Page not found</h1>
            <p className="text-slate-400 text-sm mt-1">The page you're looking for doesn't exist.</p>
            <Link
                to={homeFor(user?.role)}
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-[#8b5cf6] hover:bg-[#7c3aed] text-white text-sm font-semibold transition-colors"
            >
                <ArrowLeft size={16} />
                Back home
            </Link>
        </div>
    );
}